// extracted by mini-css-extract-plugin
var _1 = "CalendarSettings-moduleskeleton__QCMX6 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
